import { MessageStatus } from '../constants/messageStatus';

export const LAYER_ZERO_SCAN_API_URL =
  'https://scan.layerzero-api.com/v1/messages/tx';

type LayerZeroScanPayload = {
  data?: Array<{
    destination?: {
      tx?: {
        txHash?: string;
      };
    };
    status?: {
      name?: string;
    };
  }>;
};

export type LayerZeroMessage = {
  status: MessageStatus;
  dstTxHash: `0x${string}`;
};

export function parseLayerZeroScanMessage(
  payload: unknown
): LayerZeroMessage | null {
  if (!payload || typeof payload !== 'object') {
    throw new Error('Invalid LayerZero Scan response');
  }

  const data = (payload as LayerZeroScanPayload).data;
  if (!Array.isArray(data)) {
    throw new Error('Invalid LayerZero Scan response');
  }

  const message = data[0];
  if (!message) {
    return null;
  }

  const status =
    message.status?.name === MessageStatus.DELIVERED
      ? MessageStatus.DELIVERED
      : message.status?.name === MessageStatus.FAILED
        ? MessageStatus.FAILED
        : MessageStatus.INFLIGHT;
  const dstTxHash = message.destination?.tx?.txHash;

  return {
    status,
    dstTxHash:
      typeof dstTxHash === 'string' && dstTxHash.startsWith('0x')
        ? (dstTxHash as `0x${string}`)
        : ('0x' as `0x${string}`),
  };
}

export async function getLayerZeroMessage(
  srcTxHash: `0x${string}`,
  signal?: AbortSignal
): Promise<LayerZeroMessage | null> {
  const response = await fetch(`${LAYER_ZERO_SCAN_API_URL}/${srcTxHash}`, {
    signal,
  });

  if (!response.ok) {
    throw new Error(`LayerZero Scan request failed (${response.status})`);
  }

  return parseLayerZeroScanMessage(await response.json());
}
